import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, EyeOff, Eye } from "lucide-react";

/**
 * Sidebar header — brand logo + name + collapse button.
 * Collapses down to the icon-only rail with a bold TEAL expand chevron
 * at the top (mirrors the one in the sidebar footer) so users can pop
 * the nav open from either end.
 */
export default function SidebarBrand({ brandName, collapsed, onCollapse, hideRoadmap, onToggleRoadmap }) {
  return (
    <div className={`${collapsed ? "flex-col" : ""} h-auto min-h-[64px] flex items-center ${collapsed ? "justify-center py-2 px-2 gap-1" : "h-16 px-4"} border-b border-white/5`}>
      {collapsed ? (
        <>
          <button
            type="button"
            onClick={onCollapse}
            data-testid="sidebar-expand-toggle-top"
            aria-label="Expand sidebar"
            title="Expand sidebar"
            className="w-10 h-10 grid place-items-center rounded-md text-teal-300 hover:text-teal-100 hover:bg-teal-500/[0.10]"
          >
            <ChevronRight className="w-5 h-5 stroke-[3]" />
          </button>
          {onToggleRoadmap && (
            <button
              type="button"
              onClick={onToggleRoadmap}
              data-testid="sidebar-hide-roadmap-toggle"
              aria-label={hideRoadmap ? "Show roadmap items" : "Hide roadmap items"}
              title={hideRoadmap ? "Show roadmap (greyed) items" : "Hide roadmap (greyed) items"}
              className={`w-8 h-8 grid place-items-center rounded-md hover:bg-white/5 ${hideRoadmap ? "text-teal-300" : "text-slate-400 hover:text-white"}`}
            >
              {hideRoadmap ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          )}
        </>
      ) : (
        <>
          <Link to="/home" className="flex items-center gap-2.5 group min-w-0" data-testid="sidebar-brand">
            <img
              src="/logo-talmia-ii.svg"
              alt="Talmia II"
              className="w-9 h-9 rounded-lg object-cover shadow-lg shadow-orange-500/20 shrink-0 group-hover:scale-105 transition-transform"
            />
            <span className="font-display text-base font-bold tracking-tight truncate">
              {brandName}<span className="text-orange-400">II</span>
            </span>
          </Link>
          <div className="ml-auto flex items-center gap-1">
            {onToggleRoadmap && (
              <button
                type="button"
                onClick={onToggleRoadmap}
                data-testid="sidebar-hide-roadmap-toggle"
                aria-label={hideRoadmap ? "Show roadmap items" : "Hide roadmap items"}
                title={hideRoadmap ? "Show roadmap (greyed) items" : "Hide roadmap (greyed) items"}
                className={`w-7 h-7 grid place-items-center rounded-md hover:bg-white/5 ${hideRoadmap ? "text-teal-300" : "text-slate-400 hover:text-white"}`}
              >
                {hideRoadmap ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            )}
            <button
              type="button"
              onClick={onCollapse}
              data-testid="sidebar-collapse-toggle"
              aria-label="Collapse sidebar"
              className="w-7 h-7 grid place-items-center rounded-md text-slate-400 hover:text-white hover:bg-white/5"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
          </div>
        </>
      )}
    </div>
  );
}
